import { createRouter, createWebHistory } from 'vue-router'
import { basicRoutes } from './routes'

const router = createRouter({
  history: createWebHistory('/'),
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes: basicRoutes
})

router.beforeEach((_to, _from, next) => {
  // 如果不需要校验鉴权，则直接执行 next
  // if (to.meta.auth === false) {
  //   return next()
  // }
  next()
  // 反之则执行中间件
  // return auth(next)
})

export default router
